import nameModelValidator from 'forms/shared/validators/models/name/name';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import currencyModelValidator from 'forms/shared/validators/models/currency';
import { foreignBenefitFrequencyOptions, foreignBenefitTypes, foreignInterestOwnerOptions } from 'constants/enums/foreignActivityOptions';
import { hasYesOrNo } from 'models/validate';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { DATE_IN_THE_PAST } from 'constants/errors';
import { setToStartOfMonth } from 'helpers/date';
import { ForeignActivitiesOnGoingSupportItemModel } from '../types';
// this validator is used in PVQ only - all fields apply to pvq only
export const foreignActivitiesOnGoingSupportItemValidator: ValidateJSModel<ForeignActivitiesOnGoingSupportItemModel> = {

  EligiblePersonOptions: (value, attributes, attributeName, options) => ({
    hasValue: {
      validator: {
        inclusion: {
          within: foreignInterestOwnerOptions,
        },
      },
    },
  }),
  EligiblePersonName: (value, attributes, attributeName, options) => {
    if (attributes?.EligiblePersonOptions?.value === 'Dependent children') {
      return {
        presence: true,
        model: { validator: nameModelValidator },
      };
    }
    return {};
  },

  FutureBenefitType: (value, attributes, attributeName, options) => ({
    hasValue: {
      validator: {
        inclusion: {
          within: foreignBenefitTypes,
        },
      },
    },
  }),
  FutureBenefitOptionsOtherExplanation: (value, attributes, attributeName, options) => {
    if (attributes?.FutureBenefitType?.value === 'Other') {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  ExpectedDate: (value, attributes, attributeName, options) => ({
    presence: true,
    date: {
      requireday: false,
      earliest: DEFAULT_LATEST,
      tooEarly: DATE_IN_THE_PAST,
    },
  }),
  FrequencyOptions: (value, attributes, attributeName, options) => ({
    hasValue: {
      validator: {
        inclusion: {
          within: foreignBenefitFrequencyOptions,
        },
      },
    },
  }),
  FrequencyOptionsOtherExplanation: (value, attributes, attributeName, options) => {
    if (attributes.FrequencyOptions?.value?.toLocaleLowerCase() === 'other') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  EligiblePersonCountry: { hasValue: true, country: { excludeUnitedStates: true } },
  EligibleExplanation: (value, attributes, attributeName, options) => ({ presence: true, hasValue: true }),
  TotalBenefitValue: (value, attributes, attributeName, options) => ({
    presence: true,
    model: { validator: currencyModelValidator },
  }),
  Accepting: (value, attributes, attributeName, options) => ({ presence: true, hasValue: { validator: hasYesOrNo } }),
  AcceptingExplanation: (value, attributes, attributeName, options) => ({ presence: true, hasValue: true }),

  Obligated: (value, attributes, attributeName, options) => ({ presence: true, hasValue: { validator: hasYesOrNo } }),
  ObligatedExplanation: (value, attributes, attributeName, options) => ({ presence: true, hasValue: true }),
};
